export const requiredMsg = (prop: string) => `${prop} is a required field`;
export const emailMsg = (prop: string) => `${prop} must be a valid email`;
export const greaterThenMsg = (prop: string, number: number) =>
  `${prop} must be greater than or equal to ${number}`;
export const positiveNumMsg = (prop: string) => `${prop} must be a positive number`;
export const typeMsg = (prop: string, type: string) => `${prop} must be a ${type}`;
export const urlMsg = (prop: string) => `${prop} must be a valid url`;
export const atLeastOneMsg = (prop: string) => `At least one ${prop} is required`;
